import { TextField, Box, Fab, Typography } from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import { theme } from 'theme/theme';

interface MultiFechaProps {
  fechas: (Date | null)[];
  handleDateChange: (index: number, newValue: Date | null) => void;
  handleAddDateTime: () => void;
  handleRemoveDateTime: (index: number) => void;
  errors: any;
  register: any;
  label: string;
  name: string;
  mensajeValidacion: string | boolean;
}

const MultiFecha = ({
  fechas,
  handleDateChange,
  handleAddDateTime,
  handleRemoveDateTime,
  errors,
  register,
  label,
  name,
  mensajeValidacion,
}: MultiFechaProps) => {
  return (
    <>
      {fechas.map((fecha, index) => {
        const fieldName = `${name}[${index}]`;
        const isError = Boolean(errors && errors[index]);

        return (
          <Box key={index} my={1} display="flex">
            <TextField
              {...register(fieldName, {
                required: mensajeValidacion,
                // Esta función valida el valor ingresado y actualiza el estado del error
                validate: (value: any) => !!value || mensajeValidacion,
              })}
              label={`${label} ${index + 1}`}
              variant="filled"
              type="datetime-local"
              defaultValue={fecha ? fecha.toISOString().substring(0, 16) : ''}
              onChange={e => handleDateChange(index, e.target.value ? new Date(e.target.value) : null)}
              error={isError}
              helperText={isError ? errors[index]?.message : ''}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ flex: 1, mr: 2 }}
            />
            {fechas.length !== 0 && (
              <Fab color="primary" aria-label="Eliminar" onClick={() => handleRemoveDateTime(index)}>
                <RemoveIcon />
              </Fab>
            )}
          </Box>
        );
      })}
      <Box display="flex" justifyContent="end" gap={4} alignItems="center" mt={1}>
        <Typography variant="h6" fontSize={17} color={theme.palette.primary.main}>
          Agregar nueva fecha
        </Typography>
        <Fab
          aria-label="Agregar"
          onClick={handleAddDateTime}
          sx={{ color: theme.palette.primary.main, backgroundColor: theme.palette.secondary.main }}
        >
          <AddIcon />
        </Fab>
      </Box>
    </>
  );
};

export default MultiFecha;
